module.exports = __webpack_public_path__ + "static/media/SAS Alert Tone 21.a9755fd5.mp3";